import { gql } from '@apollo/client/core'

import { FILE_UPLOAD_FRAGMENT } from '@base/api/fragments/fileUpload'

export const FETCH_REVIEW_UPLOAD_QUERY = gql`
  ${FILE_UPLOAD_FRAGMENT}

  query fetchReviewUpload($fileExtension: FileExtension!) {
    fetchReviewUpload(fileExtension: $fileExtension) {
      ...FileUpload
    }
  }
`
